import Vue from 'vue'
import Vuex from 'vuex'
import AppStore from './modules/AppStore'
import AuthStore from './modules/AuthStore'
import CommonStore from './modules/CommonStore'
import ProjectStore from './modules/ProjectStore'
import PropertyDeveloperStore from './modules/PropertyDeveloperStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: AppStore,
    auth: AuthStore,
    common: CommonStore,
    projects: ProjectStore,
    propertyDeveloper: PropertyDeveloperStore
  }
})
